"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortQuotes = exports.getQuotes = exports.getCryptoSupportedProviders = exports.getAvailableProviders = void 0;
const providers_1 = require("../api/providers");
const priorities_1 = require("../data/priorities");
const getAvailableProviders = (geoLocation) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        // stores getAvailability promises
        const availabilityPromises = Object.keys(providers_1.buyProviders).map((p) => providers_1.buyProviders[p].getAvailability(geoLocation));
        // resolves getAvailability promises
        const availabilityResponses = yield Promise.all(availabilityPromises);
        return availabilityResponses;
    }
    catch (error) {
        console.log("error getting provider availabilities", error);
        return [];
    }
});
exports.getAvailableProviders = getAvailableProviders;
const getCryptoSupportedProviders = (availablePartners, cryptoCode) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const supportedCryptoPromises = availablePartners.reduce((p, c, i) => {
            if (c) {
                const provider = providers_1.buyProviders[Object.keys(providers_1.buyProviders)[i]];
                return [...p, provider.getSupportedCryptos()];
            }
            return [...p, Promise.resolve([])];
        }, []);
        // resolves getSupportedCrypto promises
        const supportedCryptoResponses = yield Promise.all(supportedCryptoPromises);
        // is crypto supported by provider
        const isSupportedList = supportedCryptoResponses.map((cryptos) => cryptos.includes(cryptoCode));
        return isSupportedList;
    }
    catch (error) {
        console.log("error getting crypto supported providers", error);
        return [];
    }
});
exports.getCryptoSupportedProviders = getCryptoSupportedProviders;
const getQuotes = (supportedCryptoPartners, cryptoCode, fiatCode, fiatAmount, geoLocation) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const quotePromises = supportedCryptoPartners.reduce((p, c, i) => {
            if (c) {
                const provider = providers_1.buyProviders[Object.keys(providers_1.buyProviders)[i]];
                return [
                    ...p,
                    provider.getBuyQuote(cryptoCode, fiatCode, fiatAmount, geoLocation),
                ];
            }
            return p;
        }, []);
        // resolves getBuyQuote promises
        const quotesResponses = yield Promise.all(quotePromises);
        return quotesResponses;
    }
    catch (error) {
        console.log("error getting quotes", error);
        return [];
    }
});
exports.getQuotes = getQuotes;
const sortQuotes = (quotes, geoLocation) => {
    const filterNotErrored = quotes.filter((i) => !i.isError);
    const sortedByCountry = filterNotErrored.sort((a) => {
        var _a;
        return (priorities_1.PRIORITY_COUNTRIES_BUY === null || priorities_1.PRIORITY_COUNTRIES_BUY === void 0 ? void 0 : priorities_1.PRIORITY_COUNTRIES_BUY[((_a = geoLocation === null || geoLocation === void 0 ? void 0 : geoLocation.alpha2) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || "DEFAULT"]) === a.provider
            ? -1
            : 0;
    });
    /*   const sortByCryptoAmount = filterNotErrored.sort(
      (a, b) => b.cryptoAmount - a.cryptoAmount
    );
  
    const sortBySelectedFiat = sortByCryptoAmount.sort((a, b) => {
      if (a.isRequestedCurrency && !b.isRequestedCurrency) return -1;
      if (a.isRequestedCurrency && b.isRequestedCurrency) return 0;
  
      return 1;
    });
  
    const notOutsideLimits = sortBySelectedFiat.sort((a) => {
      if (
        !a.limits ||
        a.fiatAmount < a.limits.min ||
        (a.fiatAmount > a.limits.max && a.limits.max !== -1)
      ) {
        return 0;
      }
  
      return -1;
    }); */
    return sortedByCountry;
};
exports.sortQuotes = sortQuotes;
//# sourceMappingURL=getQuotesBuy.js.map